import { BookOpen } from "lucide-react";

/**
 * Master v5 Prompt 9 — Content Viewer renderer. No blocks, no
 * InteractionAttempt (nothing is submitted) — a read-only guide whose
 * text is the Assignment's own `instructions_snapshot` (captured at
 * assignment time, never re-fetched live from a later Library edit).
 * "Complete" (RoomShell's own action) simply marks the instance viewed.
 */
export default function ContentViewerRenderer({ instructions }) {
  return (
    <div className="border border-ink/15 bg-white/60 rounded-lg p-6" data-testid="renderer-content-viewer">
      <div className="flex items-center gap-2 text-ink-soft mb-3">
        <BookOpen size={16} /><span className="text-sm uppercase tracking-wide">Guide</span>
      </div>
      <p className="text-ink whitespace-pre-wrap leading-relaxed" data-testid="renderer-content-viewer-body">
        {instructions || "No content was provided for this guide."}
      </p>
    </div>
  );
}
